import React, { useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import UniversalDropDown from '../dropDown/unuversalDropDown'
import { InputMask } from 'primereact/inputmask';
import '../../static/css/main.css'
import '../../static/fonts/stylesheet.css'
import { selectEmail, selectIdBank, selectInsuranceCompanyLife, setEmail, setProcessCalc, setStepCalc } from './calcSlice';
import { confirmEmail } from './calcApi';
import {
    selectDateBegin,
    selectDateContract,
    selectNumberContract,
    selectPariLifePercent,
    selectPayMonth,
    selectPercent,
    selectStringDateBegin,
    selectStringDateContract,
    setDateBegin,
    setDateContract,
    setNumberContract,
    setPariLifePercent,
    setPayMonth,
    setPercent,
    setStringDateBegin,
    setStringDateContract
} from './contractSlice';
import { selectMortgageBalance, setMortgageBalance } from '../precalc/precalcSlice';
import { list_banks } from '../../static/vars';
import { selectYearBuild } from './objectSlice';

export function DataContract() {
    const dispath = useDispatch()

    const mortgageBalance = useSelector(selectMortgageBalance)
    const numberContract = useSelector(selectNumberContract)

    const percent = useSelector(selectPercent)
    const parilifepercent = useSelector(selectPariLifePercent)
    const payMonth = useSelector(selectPayMonth)
    const idBank = useSelector(selectIdBank)

    const stringDateBegin = useSelector(selectStringDateBegin)
    const stringDateContract = useSelector(selectStringDateContract)

    const [emptyNumContract, setEmptyNumContract] = useState(false)
    const [emptyDateContract, setEmptyDateContract] = useState(false)
    const [emptyDateBegin, setEmptyDateBegin] = useState(false)

    const [correctDateBegin, setCorrectDateBegin] = useState(true)
    const [correctDateContract, setCorrectDateContract] = useState(true)
    const [IsTrueDateContract, setIsTrueDateContract] = useState(true)

    const insuranceCompanyLife = useSelector(selectInsuranceCompanyLife)



    const editDate = (value) => {
        let buf = value.split('.')
        let arr = [buf[1], buf[0], buf[2]]
        return new Date(arr.join('-'))
    }

    const checkDates = () => {
        console.log('checkDates', stringDateContract)
        const arr_date_contract = stringDateContract.split('.')
        console.log('arr_date_contract', arr_date_contract)
        let is_correct = true
        if (parseInt(arr_date_contract[0]) > 31 || parseInt(arr_date_contract[1]) > 12 || parseInt(arr_date_contract[2]) > 2024 || parseInt(arr_date_contract[2]) < 2000) {
            setIsTrueDateContract(false)
            is_correct = false
        }
        else {
            setIsTrueDateContract(true)

        }
        console.log('is_correct', is_correct)
        return is_correct ? 1 : 0
    }


    const handleChangeDateBegin = (e) => {
        dispath(setStringDateBegin(e.target.value))
    }

    const handleChangeNumberContract = (e) => {
        dispath(setNumberContract(e.target.value))
    }

    const handleChangeDateContract = (e) => {
        dispath(setStringDateContract(e.target.value))
    }

    const handleChangePayMonth = (e) => {
        dispath(setPayMonth(e.target.value))
    }

    const handleChangePercent = (e) => {

        // Проверяем, является ли введенное значение числом
        if (!isNaN(e.target.value)) {
            dispath(setPercent(e.target.value))
        }
        
    }

    const handleChangePariLifePercent = (e) => {

        // Проверяем, является ли введенное значение числом
        if (!isNaN(e.target.value)) {
            dispath(setPariLifePercent(e.target.value))
        }
        
    }

    const handleChangeMortgageBalance = (e) => {
        dispath(setMortgageBalance(e.target.value))
    }

    function checkDateBegin() {
        let today = new Date()
        today.setUTCHours(0, 0, 0, 0);
        setCorrectDateBegin(today < editDate(stringDateBegin))
        return today < editDate(stringDateBegin)
    }

    function checkDateContract() {
        let today = new Date()
        today.setUTCHours(0, 0, 0, 0);
        setCorrectDateContract(today > editDate(stringDateContract))
        return today > editDate(stringDateContract)
    }

    function checkEmptyFields() {
        let good = true
        if (stringDateContract.replaceAll(' ', '') === "") {
            setEmptyDateContract(true)
            good = false
        }
        else {
            console.log('hh')
            setEmptyDateContract(false)
        }
        if (numberContract.replaceAll(' ', '') === "") {
            setEmptyNumContract(true)
            good = false
        }
        else {
            setEmptyNumContract(false)
        }
        if (stringDateBegin.replaceAll(' ', '') === "") {
            setEmptyDateBegin(true)
            good = false
        }
        else {
            setEmptyDateBegin(false)
        }

        return good
    }

    const handleNext = () => {
        if (checkEmptyFields() && checkDates() === 1) {
            if (checkDateBegin() && checkDateContract()) {
                window.ym(90426649,'reachGoal','dogovor_ok')
                dispath(setProcessCalc('object'))
                dispath(setStepCalc('object'))
                dispath(setDateBegin(editDate(stringDateBegin)))
                dispath(setDateContract(editDate(stringDateContract)))
            }
        }

    }

    return (
        <>
            <div class="section-calculator-tab-body calculator-tab-body-2">
                <div class="calculator-tab-body-blok calculator-tab-body-blok-2">
                    <p class="calculator-tab-body-blok-title calculator-tab-body-blok-title-201">Ипотечный
                        договор</p>
                    <div class="tab-body-blok-info tab-body-blok-info-5">
                        <div class="tab-body-blok-info-row tab-body-blok-info-row-201">
                            <div class="tab-body-blok-info-element tab-body-blok-info-element-201">
                                <div class="tab-body-blok-info-element-vnutr">
                                    <label class="section-two-banks-text-2" for="pet-select">Банк кредитор</label>
                                    <div class="pole pole-step-2 txt_a_l">{list_banks.find(x => x.value === idBank).label}</div>
                                </div>
                            </div>
                            <div class="tab-body-blok-info-element tab-body-blok-info-element-202">
                                <div class="tab-body-blok-info-element-vnutr">
                                    <label class="section-two-banks-text-2" for="pet-select">Остаток по
                                        ипотеке, ₽</label>
                                    <input class="pole pole-step-2" id="num1" name="ostatok" type="text"
                                        value={mortgageBalance} placeholder="100 000 ₽" onChange={handleChangeMortgageBalance} />
                                </div>
                            </div>
                            <div class="tab-body-blok-info-element tab-body-blok-info-element-203">
                                <div class={"tab-body-blok-info-element-vnutr " + (emptyNumContract ? 'redBorder' : '')}>
                                    <label class="section-two-banks-text-2" for="pet-select">Номер
                                        кредитного договора</label>
                                    <input class="pole pole-step-2 mask-nomer-dogovor"
                                        id="pole-2.3" name="patronymic" type="text"
                                        value={numberContract}
                                        onChange={handleChangeNumberContract}
                                        onkeyup="success3()" placeholder="---- ------" />
                                </div>
                            </div>
                        </div>
                        <div class="tab-body-blok-info-row tab-body-blok-info-row-202">
                            <div class="tab-body-blok-info-element tab-body-blok-info-element-204">
                                <div class={"tab-body-blok-info-element-vnutr " + (emptyDateContract || !IsTrueDateContract ? 'redBorder' : '')}>
                                    <label class="section-two-banks-text-2" for="pet-select">
                                        Дата заключения кредитного договора
                                    </label>
                                    <InputMask mask="99.99.9999"
                                        placeholder="ДД.ММ.ГГГГ"
                                        className="pole pole-step-2 mask-date"
                                        id="pole-2.4"
                                        name="ostatok"
                                        value={stringDateContract}
                                        onChange={handleChangeDateContract} />
                                </div>
                            </div>
                            <div class="tab-body-blok-info-element tab-body-blok-info-element-205">
                                <div class={"tab-body-blok-info-element-vnutr " + (emptyDateBegin ? 'redBorder' : '')}>
                                    <label class="section-two-banks-text-2" for="pet-select">Дата начала
                                        действия полиса</label>
                                    <InputMask mask="99.99.9999"
                                        placeholder="ДД.ММ.ГГГГ"
                                        className="pole pole-step-2 mask-date"
                                        id="pole-2.5"
                                        name="ostatok"
                                        value={stringDateBegin}
                                        onChange={handleChangeDateBegin} />
                                </div>
                            </div>
                        </div>
                        <div className={`tab-body-blok-info-row tab-body-blok-info-row-20${insuranceCompanyLife === 'pari' ? 1: 3}`}>
                            <div class="tab-body-blok-info-element tab-body-blok-info-element-206">
                                <div class="tab-body-blok-info-element-vnutr">
                                    <label class="section-two-banks-text-2" for="pet-select">Годовая
                                        ставка, %</label>
                                    {/* <InputMask mask="99.9%"
                                        placeholder="--%"
                                        className="pole pole-step-2 mask-date"
                                        id="pole-2.6"
                                        name="ostatok"
                                        value={percent}
                                        autoClear={false}
                                        onChange={handleChangePercent} /> */}
                                    <input
                                        className="pole pole-step-2 mask-date"
                                        type="text"
                                        value={percent}
                                        onChange={handleChangePercent}
                                        placeholder="10"
                                    />
                                </div>
                            </div>
                            <div class="tab-body-blok-info-element tab-body-blok-info-element-206" style={insuranceCompanyLife === 'pari'? {}:{display: 'none'}}>
                                <div class="tab-body-blok-info-element-vnutr">
                                    <label class="section-two-banks-text-2" for="pet-select">
                                        Ставка при отсутствии страховки, %
                                    </label>
                                    <input
                                        className="pole pole-step-2 mask-date"
                                        type="text"
                                        value={parilifepercent}
                                        onChange={handleChangePariLifePercent}
                                        placeholder="10"
                                    />
                                </div>
                            </div>
                            <div class="tab-body-blok-info-element tab-body-blok-info-element-207">
                                <div class="tab-body-blok-info-element-vnutr">
                                    <label class="section-two-banks-text-2" for="pet-select">Ежемесячный
                                        платёж</label>
                                    <input class="pole pole-step-2 pole-2.7" id="num2" name="patronymic"
                                        type="text"
                                        value={payMonth}
                                        onChange={handleChangePayMonth}
                                        placeholder="-" />
                                </div>
                            </div>
                        </div>
                        <div type="submit" class="button button-1 button-novostroiki-1 button-step-23"
                            id="button-step-23" value="Далее" disabled
                            onClick={handleNext}
                        >
                            Далее
                        </div>

                        {(emptyNumContract || emptyDateContract) &&
                            <div class="validacia-3">
                                <p id="validacia-text"
                                    class="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-animation-text-22 tab-body-blok-info-element-400-text">
                                    Заполните все поля
                                </p>
                            </div>
                        }
                        {!correctDateBegin &&
                            <div class="validacia-3">
                                <p id="validacia-text"
                                    class="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-animation-text-22 tab-body-blok-info-element-400-text">
                                    Дата начала действия полиса должна быть больше текущей
                                </p>
                            </div>
                        }
                        {!correctDateContract &&
                            <div class="validacia-3">
                                <p id="validacia-text"
                                    class="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-animation-text-22 tab-body-blok-info-element-400-text">
                                    Дата договора должна быть меньше текущей
                                </p>
                            </div>
                        }
                        {(!IsTrueDateContract) &&
                            <div className="validacia-3">
                                <p id="validacia-text"
                                    className="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-animation-text-22 tab-body-blok-info-element-400-text">
                                    Некорректная дата договора</p>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    );
}



